import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { CatalogueAddorupdateComponent } from '../catalogue-addorupdate/catalogue-addorupdate.component';

@Component({
  selector: 'app-catalogue-list',
  templateUrl: './catalogue-list.component.html',
  styleUrls: ['./catalogue-list.component.css']
})
export class CatalogueListComponent implements OnInit {
  // 素材Id
  @Input() materialId: any; 
  // 删除弹框对象
  @Input() trim:any;
  // 点击目录跳转到指定页：抛出事件
  @Output() toPage = new EventEmitter();
  // 目录列表数据
  catalogueList:any = [];
  // 目录树数据
  catalogueDatas:any = [];
  // 选择的目录id
  parentId = '';
  constructor(
    private box: SwMassageBoxService,
    private create: SwCreateModalComponentService,
    private kmsService: KmsService
  ) { }

  ngOnInit() {
    // 查询素材目录数据
    this.getCatalog();
  }

  // 查询目录
  getCatalog(){
    this.kmsService.queryMaterialMenuList(this.materialId).subscribe(
      data => {
        let res = data.data;
        if(res){
          this.catalogueList = res;
          // 按照起始页码升序排列
          res = res.sort(function (a, b) { return a.startPage - b.startPage });
          res.forEach(element => {
            element['isOpen'] = true;
            element['children'] = [];
          });
          this.catalogueDatas = this.dealTreeData('root', res);
        }else{
          this.catalogueList = [];
          this.catalogueDatas = [];
        }
      }
    );
  }

  // 选择目录
  selectClick(event){
    this.parentId = event;
    let item = this.catalogueList.filter(el => el.menuId == event);
    if(item.length>0){
      this.toPage.emit(item[0].startPage);
    }
  }

  // 添加目录
  clickAddMenu() {
    let params = {
        upOrAdd: 'Add',
        menuId: '',
        parentId: this.parentId,
        materialId: this.materialId
    };
    this.create.createModal(CatalogueAddorupdateComponent, params, this.getCatalog.bind(this));
  }

  // 编辑目录
  clickEditMenu(menuId) {
    let params = {
        upOrAdd: 'Edit',
        menuId: menuId,
        materialId: this.materialId
    };
    this.create.createModal(CatalogueAddorupdateComponent, params, this.getCatalog.bind(this));
  }

  // 删除目录
  clickDeleteMenu(menuId) {
    this.trim.openCLick('是否删除当前目录（注意：删除父级目录时，子级会一并删除）？', (data) => {
        if (data) {
            let ids = [menuId];
            this.kmsService.deleteMaterialMenuById(ids).subscribe(
                data => {
                    if (data.code == '200') {
                        this.box.success('删除成功！');
                        this.getCatalog();
                    } else {
                        this.box.waring(data.msg);
                    }
                }
            );
        }
    });
  }
   
  // list转tree结构
  dealTreeData(parentId,list){
    let arr = list.filter(el => el.parentId == parentId);
    arr.forEach(item => {
      let children = this.dealTreeData(item.menuId,list);
      if(children.length>0){
        item.children =children;
      }
    });
    return arr;
  }
}
